import styled from 'styled-components';

export const ManagerBodyLayout = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    max-width: 1440px;
    min-width: 880px;
    gap: 16px;
`;
